import React from "react";
import { init } from "@noriginmedia/norigin-spatial-navigation";
import { Menu } from "./sidebar";
import ContentLoader from "../common/ContentLoader";

/**
 * PageLayout - A layout component that keeps the sidebar visible during loading
 *
 * This component wraps pages that use the sidebar layout.
 * During loading states:
 * - The sidebar remains visible but navigation is disabled
 * - The content area shows a skeleton or loading indicator
 *
 * @param {boolean} loading - Local loading state for this page
 * @param {React.ReactNode} children - The page content to render
 * @param {string} focusKey - Optional focus key for spatial navigation
 * @param {string} skeletonType - Type of skeleton: 'home', 'detail', 'search', 'profile', or null for spinner
 */
export default function PageLayout({
  children,
  loading = false,
  focusKey = "MENU",
  skeletonType = null
}) {
  // Initialize spatial navigation
  React.useEffect(() => {
    init({
      debug: false,
      visualDebug: false,
      rtl: true,
    });
  }, []);

  return (
    <div className="legacy-app-shell">
      <div className="legacy-app-shell-sidebar">
        <Menu focusKey={focusKey} />
      </div>
      <div className="legacy-app-shell-content">
        <ContentLoader localLoading={loading} skeletonType={skeletonType}>
          {children}
        </ContentLoader>
      </div>
    </div>
  );
}

